import React from "react"
import SbEditable from "storyblok-react"
import linkHandler from "../../helpers/storyblokLinkHandler"

import { blokType, sbLinkType } from "../../types"

export interface LinkBlokProps extends blokType {
  label: string
  link: sbLinkType
  target: string
}

export interface LinkProps {
  blok: LinkBlokProps
  className?: string
}

const Link: React.FC<LinkProps> = ({ blok, className }) => {
  return (
    <SbEditable content={blok}>
      <a
        href={linkHandler(blok.link)}
        className={className || ""}
        title={blok.label}
        target={blok.target || "_self"}
      >
        {blok.label}
      </a>
    </SbEditable>
  )
}

export default Link
